import { render, staticRenderFns } from "./BusGisWinningRecordList.vue?vue&type=template&id=3a208b96&scoped=true&"
import script from "./BusGisWinningRecordList.vue?vue&type=script&lang=js&"
export * from "./BusGisWinningRecordList.vue?vue&type=script&lang=js&"
import style0 from "./BusGisWinningRecordList.vue?vue&type=style&index=0&id=3a208b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a208b96",
  null
  
)

export default component.exports